/**
 * File upload manager
 */
class FileUploadManager {
    constructor(validator) {
        this.validator = validator;
        this.selectedFiles = [];
        this.programmaticallyUpdatingFiles = false;
        this.dropZone = document.getElementById('drop-zone');
        this.fileInput = document.getElementById('document-files');
        this.fileListEl = document.getElementById('file-list');
        this.browseFilesTrigger = document.getElementById('browse-files');
    }

    initialize() {
        this.attachEventListeners();
    }

    attachEventListeners() {
        if (this.browseFilesTrigger && this.fileInput) {
            this.browseFilesTrigger.addEventListener('click', (e) => {
                e.preventDefault();
                this.fileInput.click();
            });
        }

        if (this.fileInput) {
            this.fileInput.addEventListener('change', (e) => {
                if (!this.programmaticallyUpdatingFiles) {
                    this.addFiles(e.target.files);
                }
            });
        }

        if (this.dropZone) {
            this.initializeDropZone();
        }
    }

    initializeDropZone() {
        ['dragenter', 'dragover'].forEach(evt => {
            this.dropZone.addEventListener(evt, (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.dropZone.classList.add('dragover');
            });
        });

        ['dragleave', 'dragend', 'drop'].forEach(evt => {
            this.dropZone.addEventListener(evt, (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.dropZone.classList.remove('dragover');
            });
        });

        this.dropZone.addEventListener('drop', (e) => {
            const dt = e.dataTransfer;
            if (dt && dt.files) {
                this.addFiles(dt.files);
            }
        });
    }

    addFiles(newFiles) {
        const filesArray = Array.from(newFiles || []);
        if (filesArray.length === 0) return;

        // Only one file is allowed per upload. Any new upload replaces the previous one.
        const file = filesArray[0];
        const validationError = this.validator.validateFileField({ files: [file] });

        if (validationError) {
            this.updateInputFiles();
            if (this.fileInput) {
                this.validator.showFieldError(this.fileInput, validationError);
            }
            return;
        }

        // A replacement happens either when there is already a file selected
        // or when the customer picks/drops more than one file at once.
        const limitReached = this.selectedFiles.length > 0 || filesArray.length > 1;

        this.selectedFiles = [file];
        this.updateInputFiles();

        if (this.fileInput) {
            if (limitReached) {
                this.validator.showFieldError(
                    this.fileInput,
                    'File limit reached. Only 1 file is allowed — the previous upload has been replaced with the new one.'
                );
            } else {
                this.validator.clearFieldError(this.fileInput);
            }
        }
    }

    updateInputFiles() {
        if (!this.fileInput) return;

        this.programmaticallyUpdatingFiles = true;
        const dataTransfer = new DataTransfer();
        this.selectedFiles.forEach(file => dataTransfer.items.add(file));
        this.fileInput.files = dataTransfer.files;
        this.programmaticallyUpdatingFiles = false;

        this.renderFileList();
    }

    renderFileList() {
        if (!this.fileListEl) return;

        this.fileListEl.innerHTML = '';
        if (!this.selectedFiles.length) return;

        this.selectedFiles.forEach((file, index) => {
            const listItem = this.createFileListItem(file, index);
            this.fileListEl.appendChild(listItem);
        });
    }

    createFileListItem(file, index) {
        const li = document.createElement('li');

        if (file.type && file.type.startsWith('image/')) {
            const thumb = document.createElement('div');
            thumb.className = 'file-thumb';
            const img = document.createElement('img');
            img.alt = file.name;

            try {
                img.src = URL.createObjectURL(file);
                img.onload = () => URL.revokeObjectURL(img.src);
            } catch (err) {
                console.error('Error creating object URL:', err);
            }

            thumb.appendChild(img);
            li.appendChild(thumb);
        }

        const meta = document.createElement('span');
        meta.className = 'file-meta';
        meta.textContent = `${file.name} (${(file.size / 1024 / 1024).toFixed(2)} MB)`;

        const removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'remove-file';
        removeBtn.textContent = 'Remove';
        removeBtn.addEventListener('click', () => {
            this.removeFile(index);
        });

        li.appendChild(meta);
        li.appendChild(removeBtn);

        return li;
    }

    removeFile(index) {
        this.selectedFiles.splice(index, 1);
        this.updateInputFiles();

        if (this.fileInput && this.selectedFiles.length === 0) {
            this.validator.showFieldError(this.fileInput, 'Please upload at least one file.');
        }
    }
}

